import { createSlice,nanoid } from "@reduxjs/toolkit";
const initialState={
    todos:[{
        id:1,
        description:"Need to complete full stack course"
    }]
}

export const todoslice=createSlice({
    name:'todo',
    initialState,
    reducers:{
        addTodo:(state,action)=>{
            const todo={
                id:nanoid(),
                description:action.payload
            }
            state.todos.push(todo)
        },
        removeTodo:(state,action)=>{
            state.todos=state.todos.filter((item)=> item.id !== action.payload)

        },
        updateTodo:(state,action)=>{
            const { id, changes } = action.payload; 
            const { description } = changes; 
            console.log(id, description, "this is the payload", action.payload);
            const todoToUpdate = state.todos.find(item => item.id === id);
            console.log("todoToUpdate", todoToUpdate);
            if (todoToUpdate) {
                todoToUpdate.description = description;
            }
        }
    }
})
export const {addTodo,removeTodo,updateTodo}=todoslice.actions;
export default todoslice.reducer